import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const caseDeleteEndpoint = ApiEndpoints.caseStudy.caseDelete;
const caseListEndpoint = ApiEndpoints.caseStudy.caseList;
const caseEditPath = "edit-casestudy";
const tableHeader = ["Date","Title","Slug"];
const tbody = ["date","title","slug"];

export default function CasestudyListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", caseListEndpoint);
      const result = response.casestudies;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

    const handleDelete = async (casestudy_id) => {
        const payload = { casestudy_id };
        try {
        const response = await ApiRequest("POST", caseDeleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
        } catch (error) {
        console.error(error);
        }
    };

    const pagename = {
      name: 'Case Study Management',
      user: 'Admin',
      innerpage: 'Case Study Management / Case Study'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-casestudy">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={caseEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
